<ng-container *ngIf="{ isLoggedIn: isLoggedIn$ | async } as userData">
  <div id="header-mobile-navigation">
    <div class="d-flex justify-content-end align-items-center">
      <py-header-navigation-item
        *ngIf="userData.isLoggedIn"
        class="menu-item"
        [ariaLabel]="'navigation.myPage_tab_mobile' | cxTranslate"
        (click)="goToDashboard()"
      >
        <i nz-icon nzType="user"></i>
      </py-header-navigation-item>
      <py-header-navigation-item
        *ngIf="!userData.isLoggedIn"
        class="menu-item"
        [ariaLabel]="'navigation.signIn_tab_mobile' | cxTranslate"
        (click)="goToLoginPage()"
      >
        <i nz-icon nzType="login"></i>
      </py-header-navigation-item>
      <py-menu-cart-authenticated *ngIf="userData.isLoggedIn" class="menu-item"></py-menu-cart-authenticated>
      <py-menu-cart-anonymous *ngIf="!userData.isLoggedIn" class="menu-item"></py-menu-cart-anonymous>
      <py-header-navigation-item class="menu-item" [ariaLabel]="'navigation.menu_tab_mobile' | cxTranslate" (click)="openMenu()">
        <i nz-icon nzType="menu" nzTheme="outline"></i>
      </py-header-navigation-item>
    </div>
    <div *ngIf="searchBoxVisible$ | async">
      <py-search class="px-3 mobile-view" [hidden]="!(mobileVisible$ | async)"></py-search>
    </div>
  </div>

  <ng-template #menuDrawerTemplate>
    <py-drawer-template
      #drawerTemplate
      [title]="drawerTitle"
      [body]="drawerBody"
      [rootShowBackButton]="currentState !== state.Menu"
      (backButtonClick)="handleBackButtonClick()"
    >
    </py-drawer-template>

    <ng-template #drawerBody>
      <ng-container [ngSwitch]="currentState">
        <py-mobile-navigation-links
          *ngSwitchCase="state.Menu"
          [navigationNode]="navigationNode | async"
        ></py-mobile-navigation-links>

        <div class="mx-4 mt-5">
          <ul
            py-categories-navigation
            *ngSwitchCase="state.ProductsMenu"
            [mobile]="true"
            (setActiveCategoryCode)="handleCategoryCodeChange($event)"
            (setActiveAddonGroup)="handleAddonGroupChange($event)"
            (setShowMyAssortmentSubmenu)="handleShowMyAssortmentSubMenuChange()"
            (setShowCampaignsSubMenu)="handleShowCampaignsSubMenuChange()"
          ></ul>

          <ul
            py-sub-categories-navigation
            *ngSwitchCase="state.ProductsSubMenu"
            [activeCategoryCode]="activeSubId"
            [mya]="mya"
          ></ul>

          <ul py-campaigns-sub-navigation *ngSwitchCase="state.CampaignsSubMenu" [mya]="mya"></ul>

          <ul py-my-assortment-sub-navigation [mya]="mya" *ngSwitchCase="state.MyAssortmentProductsSubMenu"></ul>

          <ul py-sub-addon-group-navigation *ngSwitchCase="state.AddonSubMenu" [addonGroupId]="activeSubId"></ul>

          <py-menu-area-of-use-categories
            *ngSwitchCase="state.AreaOfUseMenu"
            [activeCategory]="activeAreaOfUseCategory"
            (setActiveCategory)="setActiveAreaofUseCategory($event)"
          ></py-menu-area-of-use-categories>

          <py-menu-area-of-use-sub-categories
            *ngSwitchCase="state.AreaOfUseSubMenu"
            [category]="activeAreaOfUseCategory"
          ></py-menu-area-of-use-sub-categories>
        </div>

        <ng-container *ngSwitchCase="state.ServicesMenu" [ngTemplateOutlet]="servicesTemplate"></ng-container>
        <ng-container *ngSwitchCase="state.SubMenu" [ngTemplateOutlet]="subMenuTemplate"></ng-container>
        <ng-container *ngSwitchCase="state.ChangeCustomer" [ngTemplateOutlet]="changeCustomerTemplate"></ng-container>
      </ng-container>
    </ng-template>

    <ng-template #servicesTemplate>
      <py-mobile-navigation-services
        [label]="'navigation.services_title' | cxTranslate"
        [filterTag]="'services'"
        [labelAntIcon]="'tool'"
      ></py-mobile-navigation-services>
      <py-mobile-navigation-services
        [label]="'navigation.educations_title' | cxTranslate"
        [filterTag]="'educations'"
        [labelAntIcon]="'book'"
      ></py-mobile-navigation-services>
    </ng-template>

    <ng-template #subMenuTemplate>
      <ul class="px-4">
        <li py-megamenu-list-item *ngFor="let subItem of subItems">
          {{ subItem.title }}
        </li>
      </ul>
    </ng-template>

    <ng-template #changeCustomerTemplate>
      <ng-container *ngIf="userData.isLoggedIn">
        <ng-container
          *ngIf="{
            activeSoldTo: activeSoldTo$ | async,
            availableSoldTos: availableSoldTos$ | async,
            soldTosLoading: soldTosLoading$ | async,
          } as data"
        >
          <div class="p-2">
            <form [formGroup]="form">
              <input
                type="text"
                class="form-control"
                [formControlName]="'search'"
                [placeholder]="'navigation.search_action_placeholder_mobile' | cxTranslate"
                [size]="24"
              />
            </form>
          </div>
          <ul class="change-customer-dropdown" infiniteScroll (scrolled)="fetchMoreSoldTos()" [scrollWindow]="false">
            <li
              *ngFor="let soldTo of data.availableSoldTos"
              class="p-3"
              [attr.active]="data.activeSoldTo?.uid === soldTo.uid ? 'true' : null"
              (click)="selectSoldTo(soldTo.uid)"
            >
              <span class="mr-3 change-customer-dropdown-uid">{{ soldTo.name }}</span>
              <ng-container
                *ngIf="{
                  address:
                    ('enableDisplayDefaultShipToAsSoldToAddress' | principalConfigValue)
                      ? soldTo?.shipTo
                      : soldTo?.customerAddress,
                } as soldToData"
              >
                <span *ngIf="soldToData?.address?.computedDescription">{{ soldToData.address.computedDescription }}</span>
              </ng-container>
            </li>
          </ul>
          <div class="py-2 text-center" *ngIf="data.soldTosLoading">
            <cx-spinner></cx-spinner>
          </div>
        </ng-container>
      </ng-container>
    </ng-template>
  </ng-template>
</ng-container>
